import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import NavigationBar from '../components/NavigationBar';
import { LinkContainer } from 'react-router-bootstrap';
import { useTheme } from '../../ThemeContext';
import '../../styles/adminPage.scss';

function AdminPage() {
    const { theme } = useTheme();

    return (
        <div id="admin-page" data-theme={theme}>
            <NavigationBar />
            <Container>
                <h1>Admin Page</h1>
                <Row>
                    <Col md={6} lg={4} className="mb-3">
                        <Card>
                            <Card.Body>
                                <Card.Title>Admin Console</Card.Title>
                                <Card.Text>Manage users and roles.</Card.Text>
                                <LinkContainer to="/admin/console">
                                    <Button>Go to Admin Console</Button>
                                </LinkContainer>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} lg={4} className="mb-3">
                        <Card>
                            <Card.Body>
                                <Card.Title>Reported Problems</Card.Title>
                                <Card.Text>View all user-reported issues.</Card.Text>
                                <LinkContainer to="/admin/reported-problems">
                                    <Button>View Reported Problems</Button>
                                </LinkContainer>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AdminPage;
